import { useRef } from "react";
import type { ReactNode } from "react";

interface ScrollRowProps {
  children: ReactNode;
}

export default function ScrollRow({ children }: ScrollRowProps) {
  const trackRef = useRef<HTMLDivElement>(null);

  const scrollByAmount = (direction: number) => {
    const node = trackRef.current;
    if (!node) return;
    node.scrollBy({ left: direction * node.clientWidth * 0.8, behavior: "smooth" });
  };

  return (
    <div className="relative">
      <div
        ref={trackRef}
        className="no-scrollbar flex gap-4 overflow-x-auto scroll-smooth pb-1"
      >
        {children}
      </div>
      <div className="mt-4 flex items-center justify-end gap-2">
        <button
          type="button"
          aria-label="向左滚动"
          onClick={() => scrollByAmount(-1)}
          className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full border border-background-300 text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
        >
          <i className="ri-arrow-left-s-line text-xl" />
        </button>
        <button
          type="button"
          aria-label="向右滚动"
          onClick={() => scrollByAmount(1)}
          className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full border border-background-300 text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
        >
          <i className="ri-arrow-right-s-line text-xl" />
        </button>
      </div>
    </div>
  );
}